import React, { useEffect, useMemo, useState } from "react";
import "../scss/button.scss";
import "../scss/FinalCongratulations.scss";
import { ReactComponent as GoldTrophy } from "../images/gold-trophy.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import PageHeader from "../components/PageHeader";
import GooglePlay from "../images/google-play.png";
import AppStore from "../images/app-store.png";
import { useSkipPageMutation } from "../lib/services/businessApi";
import { useLocation, useNavigate } from "react-router-dom";
import CenteredPopup from "../components/popups/CenteredPopup";
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { useTapClickMutation } from "../lib/middleware/TapClickApi";
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function FinalCongratulations() {
  const [skipPage, { isLoading: skippingPage }] = useSkipPageMutation()
  const [tapClick] = useTapClickMutation();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams]);
  const secret = useMemo(() => queryParams.get('secret'), [queryParams]);
  const [error, setError] = useState(null)
  const [isModalOpen, setIsModalopen] = useState(false)
  const type = true;
  const handleClose = () => {
    setIsModalopen(false);
    setError('');
  }

  const errorModalButtons = [
    { label: 'Close', onClick: handleClose }
  ]
  const handleSkip = async () => {
    try {
      let jwt_token
      if (jwt) {
        jwt_token = jwt
        localStorage.setItem('jwt', jwt)
      } else {
        jwt_token = localStorage.getItem('jwt')
      }
      const scrt = secret ? secret : localStorage.getItem('secret')
      const result = await skipPage({ jwt_token, scrt, page: 'final-congratulations' })
      if ((result.data && (result.data.status === 'error' || result.data.status === false)) || (result && result.status === 'error')) {
        setError(result.data.message || 'Some error occured. Please try again.')
        //handleOpen()
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        }
      } else if (result.data && result.data.http_code === 201) {
        if (result.data.message === 'Login expired! Please re-login.') {
          setError(result.data.message)
          //handleOpen()
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        } else {
          setError(result.data.message)
          //handleOpen()
        }
      } else if (result.error) {
        setError('Please check your internet or try again later.')
        //handleOpen()
      } else {
        if (result && result.data && result.data.redirect_url) {
          window.open("https://stash.page.link/68s3", "_blank")
          setTimeout(() => {
            window.location.href = result.data.redirect_url
          }, 1000);
        }
      }
    } catch (error) {
      setError('Something went wrong. Please try again later.')
    }
  }

  useEffect(() => {
    pushCleverTapEvent({
      event_name: 'web_congratulations_screen',
      event_property: {
        Source: window.localStorage.getItem('utm_source'),
        segment: localStorage.getItem('customerSegment'),
      }
    });
  }, [tapClick]);

  return (
    <div className="external-wrapper">
      <div className="page-content enach-success-page">
        <PageHeader />
        <div className="final-trophy">
          <div className="checkmark-container">
            <div className="checkmark-circle">
              <GoldTrophy className="checkmark-icon" />
            </div>
          </div>
          <h1 className="title">Congratulations!</h1>
          <p className="subtitle">
            Funds will be transferred to <br /> your bank account shortly
          </p>
        </div>

        {type ? (
          <div className="unlock-info-welcome-back final-logo-container">
            <p className="title">
              Download Stashfin app to <br /> manage your loan better
            </p>
            <div className="logo-links">
              <StarfinLogo className="logo" />
              <div className="download-links">
                <a href="https://stash.page.link/68s3" target="_blank" rel="noreferrer">
                  <img src={AppStore} alt="App Store" />
                </a>
                <a href="https://stash.page.link/68s3" target="_blank" rel="noreferrer">
                  <img src={GooglePlay} alt="Play Store" />
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="amount-container final-congratulations-amount-container">
            <p className="amount-label">
              You can easily manage your loan <br /> and access detailed loan
              information <br /> through the Stashfin app
            </p>
          </div>
        )}

        <div className="bottom-footer final-bottom-footer">
          {!type && (
            <p className="powered-by">
              {" "}
              Powered by <StarfinLogo />{" "}
            </p>
          )}

          <button
            type="submit"
            className={`btn btn-primary ${skippingPage ? 'disabled' : ''}`}
            onClick={handleSkip}
          >
            Download Stashfin App
          </button>
        </div>
      </div>
      <CenteredPopup
        isOpen={isModalOpen}
        buttons={errorModalButtons}
        onClose={handleClose} icon={<WarningIcon />}>
        <p>{error}</p>
      </CenteredPopup>
    </div>
  );
}

export default FinalCongratulations;
